import React, { useEffect, useState } from "react";
import { RegionDropdown } from "react-country-region-selector";
import "./MyAddressesContainer.css"
import { Col, Container, Form, Modal, Row, Spinner, Toast, ToastContainer } from "react-bootstrap";
import AddressBox from "../AddressBox/AddressBox";
import axios from "axios";
import { useSelector } from "react-redux";
import { data } from "react-router-dom";
import AlertContainer from "../Alert/Alert";
function MyAddressesContainer() {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  const [block, setBlock] = useState("");
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [city, setCity] = useState('')
  // const [region, setRegion] = useState('')
  const [cities, setCities] = useState('')
  const [address1, setAddress1] = useState('')
  const [address2, setAddress2] = useState('')
  const [region, setRegion] = useState('')
  const [street, setStreet] = useState('')
  const [house_number, setHouse_number] = useState('')
  const [notes, setNotes] = useState('')
  const [isChecked, setIsChecked] = useState(false)
  const userinfo = useSelector((state) => state);
  const [show, setShow] = useState(false);
  const [alert, setAlert] = useState('');
  const [address, setAddress] = useState([])
  const [modalShow, setModalShow] = useState(false);
      const [msg, setMsg] = useState('');
      const [severity, setSeverity] = useState('');
  const [loading, setLoading] = useState(false)

  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  const getAddress = async () => {
    await axios
      .get(`https://nanosoft.technology/outlaw/api/client/addresses`,

        {
          headers: {
            Authorization: `Bearer ${userinfo?.auth?.access_token}`
          }
        })

      .then(async (res) => {

        // setShow(true)
        console.log(res.data.data);


        setAddress(res.data.data)

      })
      .catch((error) => {
        setShow(true)

        setAddress(error.response.data);


      });
  }
  useEffect(() => {
    getAddress()
    const getAllApis = async () => {
      await axios
        .get(`https://nanosoft.technology/outlaw/api/countries/1/cities`,

          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.access_token}`
            }
          })

        .then(async (res) => {
          setCities(res.data.data.data);

          // setShow(true)

          //                     setAddress(res.data)

        })
        .catch((error) => {
          console.log(error.response.data?.message);
          
          setLoading(false)
      setShow(true)
      setMsg(error.response.data?.message)
      setSeverity("error")
setTimeout(() => {
          setShow(false)

}, 1500);


        });

    }
    getAllApis()
  }, [])


  const sendData = async (e) => {
    e.preventDefault();
    setLoading(true)
    const data = {
      "title": name,

      "city_id": city,

      latitude:
        30.123456,

      longitude:
        31.123456,

      region,

      street,
      block,
      house_number,
      notes,
      phone,


    };

    await axios
      .post(`https://nanosoft.technology/outlaw/api/client/addresses`, data,


        {
          headers: {
            Authorization: `Bearer ${userinfo?.auth?.access_token}`
          }
        })
      .then(async (res) => {
            setLoading(false)

        handleClose()
        getAddress()
        setShow(true)
setMsg(currentLocal.home.addsuccessMessage)
setSeverity("success")
setTimeout(() => {
  setShow(false);
        setName("")
        setCity("")
        setRegion("")
        setStreet("")
        setBlock("")
        setHouse_number("")
        setNotes("")
        setPhone("")

  setMsg("")

}, 2000);
      })

      .catch((error) => {
            setLoading(false)

        setAlert(error.response.data.error)
        // Toast.show("Email or password is not correct!", {
        //   type: "danger",
        // });
      });
  }
  return (
    <section className='myAddresses_container'>
      <h3>{currentLocal.home.myAddresses}</h3>

      <div className='myAddresses_box'>
        <button className='addation_btn mb-3 mx-3' onClick={handleShow}>
          {currentLocal.home.addNewAddress}
        </button>
            {show&&
            <AlertContainer
            msg={msg}
            severity={severity}
            />
      
            }
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className='edit_model'
        >
          <Modal.Header closeButton className='py-1 border-bottom-0'>

          </Modal.Header>
          <form >

            <Modal.Body>
              <Container>
                <Row>




                  <Col md={12}>
                    <div className='mb-3'>
                      <label className='mb-1'>{currentLocal.home.namePlaceholder} </label>
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={12}>


                    <label className='my-1'>{currentLocal.home.city} </label>

                    <Form.Select aria-label="Product In Stock"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}>
                      <option>City</option>
                      {cities && cities.map((item, index) => {

                        return (
                          <option value={item.id} key={index}>{item.name}</option>

                        )
                      })}
                    </Form.Select>
                  </Col>
                  <Col md={6}>
                    <div className='my-3'>
                      <label className='mb-1'>{currentLocal.home.region}  </label>
                      <input
                        placeholder={currentLocal.home.region}
                        value={region}
                        onChange={(e) => setRegion(e.target.value)}

                      />
                    </div>
                  </Col>
                  <Col md={6}>

                    <div className='my-3'>
                      <label className='mb-1'> {currentLocal.home.street}  </label>
                      <input
                        placeholder={currentLocal.home.street}
                        value={street}
                        onChange={(e) => setStreet(e.target.value)}

                      />
                    </div>
                  </Col>
                  <Col md={6}>

                    <div className='mb-3'>
                      <label className='mb-1'>{currentLocal.home.buildingNumber}  </label>
                      <input
                        placeholder={currentLocal.home.buildingNumber}
                        value={block}
                        onChange={(e) => setBlock(e.target.value)}

                      />
                    </div>
                  </Col>
                  <Col md={6}>

                    <div className='mb-3'>
                      <label className='mb-1'>{currentLocal.home.house_number}  </label>
                      <input
                        placeholder={currentLocal.home.house_number}
                        value={house_number}
                        onChange={(e) => setHouse_number(e.target.value)}

                      />
                    </div>
                  </Col>
                  <Col md={12}>

                    <div className='my-3'>
                      <label className='mb-1'>{currentLocal.home.phone} </label>
                      <input
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}

                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className='mb-3'>
                      <label className='mb-1'>{currentLocal.home.Detailedaddress}  </label>

                      <input
                        placeholder={currentLocal.home.Detailedaddress}

                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}

                      />
                    </div>
                  </Col>

                </Row>
              </Container>








            </Modal.Body>
          </form>

          <Modal.Footer className='justify-content-between'>

            {/* <button type="submit" className=" edit_btn " onClick={sendData}>{currentLocal.home.Save}</button> */}
        <button className={loading?'disaactive_login_btn d-flex justify-content-center align-items-center':'login_btn d-flex justify-content-center align-items-center'} type='submit'disabled={loading && true}onClick={sendData}>
                      {loading &&
                                    <Spinner animation="border" role="status" className='mx-3' size="sm">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                }
                                  <p className='mb-0'>  
              {currentLocal.home.add}
              </p>
            </button>
          </Modal.Footer>
        </Modal>

        <Container fluid>
          <Row>
            {address?.length > 0 && address?.map((item, index) => {
              return (
                <Col md={12}
                  key={index}
                >
                  <AddressBox
                    defaultState={true}
                    item={item}
                    getAddress={getAddress}

                  />
                </Col>

              )
            })}

          </Row>
        </Container>
      </div>

    </section>
  )
}

export default MyAddressesContainer